import * as React from "react";

const SvgChevronUp = props => <svg width="100%" height="100%" viewBox="0 0 9 5" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.13455e-08 4.04858L1.0575 5L4.5 1.90958L7.9425 5L9 4.04858L4.5 5.82787e-08L1.13455e-08 4.04858Z" fill="currentColor" /></svg>;

export default SvgChevronUp;